fragment PolicyAdminFields on PolicyAdmin {
  id
  title
  ownerId
  ownerName
  ownerLeftOn
  currentVersion
  url
  effectiveOn
  active
  requireReackOnVersionChange
  versionChangedOn
  reackWithinDays
  reviewEveryMonths
  nextReviewOn
  lastReviewedOn
  attention
}
